import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import api, { settleBalance } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { AlertTriangle } from "lucide-react";

export default function BalanceBanner() {
  const { user, setUser } = useAuth();
  const location = useLocation();
  const [busy, setBusy] = useState(false);
  const owed = Math.round((user?.balance_owed || 0) * 100) / 100;

  useEffect(() => {
    if (!user || user.is_admin || owed <= 0) return;
    api.get("/auth/me").then(({ data }) => { if ((data.balance_owed || 0) !== (user.balance_owed || 0)) setUser(data); }).catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  if (!user || user.is_admin || owed <= 0) return null;
  return (
    <div className="flex flex-wrap items-center justify-center gap-3 bg-red-600 px-4 py-2.5 text-sm text-white" data-testid="balance-owed-banner">
      <AlertTriangle className="h-4 w-4 shrink-0" />
      <span data-testid="balance-owed-banner-text">You owe AED {owed} for an order that couldn't be delivered. Settle it to buy or claim items again.</span>
      <button type="button" disabled={busy} data-testid="balance-owed-banner-settle" onClick={async () => { setBusy(true); await settleBalance(); setBusy(false); }}
        className="rounded-full bg-white px-4 py-1 text-xs font-semibold text-red-700 transition-colors hover:bg-red-50 disabled:opacity-60">
        {busy ? "Starting…" : "Settle balance"}
      </button>
    </div>
  );
}
